import * as types from "../actions/types";



const initialState = {
  list: [],
  loading: false
};


export default function event_levels (state = initialState, action) {
  switch (action.type) {
    
    case types.SET_EVENT_LEVELS_LIST:
      return {
        ...state,
        list: action.payload,
      };
    
    case types.SET_EVENT_LEVELS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
  
    default:
      return state;
  }
}